import React, { memo, useEffect } from "react";
import { Table } from "antd";
// import MainLayout from "../Layout/mainLayout";
import ListTopSearch from "./listTopSearch";
import "../Styles/tableStyles.css";

const TableComponent = ({
  pagination,
  dataSource,
  onChange,
  loading,
  setState,
  h3heading,
  buttonhead,
  buttonhead2,
  onPressEnter,
  navigateTo2,
  columns,
  filterFunction,
  navigateTo,
  onDownloadUser,
  onDownload,
  onCalendarClick,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
      <div
        className="row-span-8"
        style={{ gridColumn: "span 5", height: "auto" }}
      >
        <div className="table_component_all">
          <ListTopSearch
            buttonhead2={buttonhead2}
            navigateTo2={navigateTo2}
            h3heading={h3heading}
            setState={setState}
            onPressEnter={onPressEnter}
            filterFunction={filterFunction}
            onCalendarClick={() => onCalendarClick(false)}
            buttonhead={buttonhead}
            navigateTo={navigateTo}
            onDownload={onDownload}
            onDownloadUser={onDownloadUser}
          ></ListTopSearch>
          <div className="custom_table">
            <div style={{ width: "90%" }}>
              <Table
                virtual
                scroll={{ x: 1700, y: 500 }}
                // scroll={{ x: "max-content" }}
                dataSource={dataSource}
                pagination={pagination}
                onChange={onChange}
                loading={loading}
                columns={columns}
                rowClassName={() => "text-center"}
              ></Table>
            </div>
          </div>
        </div>
      </div>
  );
};

export default memo(TableComponent);
